import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=1a1b1f63&scoped=true&"
import script from "./forgetPassword.vue?vue&type=script&lang=js&"
export * from "./forgetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1b1f63",
  null
  
)

export default component.exports